export class IdentityProvidersNames {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providers",
            "baseName": "providers",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IdentityProvidersNames.attributeTypeMap;
    }
    constructor() {
    }
}
